import { render, staticRenderFns } from "./QuestionAnswerCard.vue?vue&type=template&id=056f486a&"
import script from "./QuestionAnswerCard.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports